import axiosUtils from '../utils/axios';

const getVersion = async (): Promise<string> => {
    const result = await axiosUtils.instance.get<string>("api/about/version");
    return result.data;
}

export default{
    getVersion
}